import { Capacitor } from "@capacitor/core";

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const platform = (): "android" | "ios" | "web" => {
  const p = Capacitor.getPlatform();
  return p === "android" || p === "ios" ? p : "web";
};
